<div class="flex items-start justify-between gap-4">
  <div class="flex flex-col gap-1">
    <h3>Información de la empresa</h3>
    <span class="cd-text-b4 text-neutral-500">Detalle administrativo visible para la empresa.</span>
  </div>
</div>

<div class="flex flex-col gap-4 rounded-2xl bg-neutral-100 p-5">
  <div class="flex flex-col gap-1">
    <h6>{{ companyName }}</h6>
    <span class="cd-text-b4 text-neutral-600">{{ roleName || 'Sin rol' }}</span>
  </div>

  @if (companyDescription) {
    <div class="cd-text-b3 text-neutral-700 whitespace-pre-wrap">{{ companyDescription }}</div>
  }

  <div class="flex flex-row flex-wrap gap-2">
    @if (companyTaxId) {
      <div class="outline primary truncate !py-1 !px-2 cd-text-b4 flex flex-row gap-2">
        <img alt="Icon" class="filter-primary-700 h-4" src="/assets/icons/feather/hash.svg">
        <span class="truncate">{{ companyTaxId }}</span>
      </div>
    }

    @if (companyCapital !== null && companyCapital !== undefined) {
      <div class="outline primary truncate !py-1 !px-2 cd-text-b4 flex flex-row gap-2">
        <img alt="Icon" class="filter-primary-700 h-4" src="/assets/icons/feather/dollar-sign.svg">
        <span class="truncate">{{ companyCapital.toLocaleString('es') }}</span>
      </div>
    }

    @for (country of countries; track country.id) {
      <div class="outline primary truncate !py-1 !px-2 cd-text-b4 flex flex-row gap-2">
        <img alt="Icon" class="filter-primary-700 h-4" src="/assets/icons/feather/flag.svg">
        <span class="truncate">{{ country.name }}</span>
      </div>
    }
  </div>
</div>

<div class="flex flex-col gap-4 rounded-2xl bg-neutral-100 p-5">
  <div class="flex flex-col gap-1">
    <h6>Facturación</h6>
    <span class="cd-text-b4 text-neutral-500">Información fiscal y de contacto visible para la empresa.</span>
  </div>

  @if (billingLoading) {
    <div class="grid grid-cols-1 md:grid-cols-2 gap-3 animate-pulse">
      @for (item of [1, 2, 3, 4, 5, 6]; track item) {
        <div class="bg-white rounded-xl px-4 py-3 flex flex-col gap-2">
          <div class="h-3 w-24 rounded bg-neutral-200"></div>
          <div class="h-4 w-full rounded bg-neutral-200"></div>
        </div>
      }
    </div>
  } @else if (billingError) {
    <div class="rounded-xl bg-white px-4 py-4 cd-text-b4 text-neutral-500">
      {{ billingError }}
    </div>
  } @else if (billing) {
    <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
      <div class="bg-white rounded-xl px-4 py-3 flex flex-col gap-1">
        <span class="cd-text-b5 text-neutral-500">Razón social</span>
        <span class="cd-text-b3 text-neutral-900">{{ billing.legalName || '-' }}</span>
      </div>
      <div class="bg-white rounded-xl px-4 py-3 flex flex-col gap-1">
        <span class="cd-text-b5 text-neutral-500">Tax ID</span>
        <span class="cd-text-b3 text-neutral-900">{{ billing.taxId || '-' }}</span>
      </div>
      <div class="bg-white rounded-xl px-4 py-3 flex flex-col gap-1">
        <span class="cd-text-b5 text-neutral-500">Email</span>
        <span class="cd-text-b3 text-neutral-900">{{ billing.email || '-' }}</span>
      </div>
      <div class="bg-white rounded-xl px-4 py-3 flex flex-col gap-1">
        <span class="cd-text-b5 text-neutral-500">Teléfono</span>
        <span class="cd-text-b3 text-neutral-900">{{ billing.phone || '-' }}</span>
      </div>
      <div class="bg-white rounded-xl px-4 py-3 flex flex-col gap-1">
        <span class="cd-text-b5 text-neutral-500">Dirección</span>
        <span class="cd-text-b3 text-neutral-900">{{ billing.address || '-' }}</span>
      </div>
      <div class="bg-white rounded-xl px-4 py-3 flex flex-col gap-1">
        <span class="cd-text-b5 text-neutral-500">Ciudad</span>
        <span class="cd-text-b3 text-neutral-900">{{ billing.city || '-' }}</span>
      </div>
      <div class="bg-white rounded-xl px-4 py-3 flex flex-col gap-1">
        <span class="cd-text-b5 text-neutral-500">Código postal</span>
        <span class="cd-text-b3 text-neutral-900">{{ billing.postalCode || '-' }}</span>
      </div>
      <div class="bg-white rounded-xl px-4 py-3 flex flex-col gap-1">
        <span class="cd-text-b5 text-neutral-500">País</span>
        <span class="cd-text-b3 text-neutral-900">{{ billing.country || '-' }}</span>
      </div>
    </div>
  } @else {
    <div class="rounded-xl bg-white px-4 py-4 cd-text-b4 text-neutral-500">
      Sin información de facturación disponible.
    </div>
  }
</div>
